import queryString from 'query-string';

export const PAYMENT_PERIOD = 'crmContactFiltersPaymentPeriod';
export const paymentPeriodFilter = {
  inputType: 'inputDate',
  query_param: PAYMENT_PERIOD,
  operators: ['between', 'gte', 'lte'],
  operatorLabels: { gte: 'crmContactFiltersFromDate', lte: 'crmContactFiltersToDate' },
  choiceValues: [],
};

export const getCondition = (filter, params) => {
  if (filter.query_param === PAYMENT_PERIOD) {
    const from = params.payments_from;
    const to = params.payments_to;
    if (from && to) return { operator: 'between', values: [from, to] };
    if (from) return { operator: 'gte', values: [from] };
    if (to) return { operator: 'lte', values: [to] };
    return null;
  }
  const value = params[filter.query_param];
  if (value === undefined) return null;
  return {
    operator: params[`${filter.query_param}__op`] || filter.operators[0],
    values: [].concat(value).map(String),
  };
};

// Clearing must also work when filter metadata could not be loaded.
export const clearConditions = params =>
  Object.fromEntries(
    ['page', 'page_size', 'ordering'].filter(key => params[key] !== undefined).map(key => [key, params[key]])
  );

export const serializeParams = params => queryString.stringify(params, { skipNull: true, skipEmptyString: true });

export const savedFilterParams = (params, filters) => {
  const keys = ['search', 'ordering', 'page_size', 'payments_from', 'payments_to'];
  Object.values(filters).forEach(filter => {
    if (filter.query_param !== PAYMENT_PERIOD) keys.push(filter.query_param, `${filter.query_param}__op`);
  });
  return Object.fromEntries(
    keys
      .filter(key => params[key] !== undefined && params[key] !== null && params[key] !== '')
      .map(key => [key, params[key]])
  );
};

export const validCondition = (filter, condition) => {
  const { values, operator } = condition;
  if (!filter.operators.includes(operator) || !values.length || values.some(value => !String(value).trim()))
    return false;
  if (filter.inputType === 'inputRange' && values.some(value => !Number.isFinite(Number(value)))) return false;
  if (filter.inputType === 'inputDate' && values.some(value => !/^\d{4}-\d{2}-\d{2}$/.test(value))) return false;
  if (['inputRange', 'inputDate'].includes(filter.inputType)) {
    const range = ['between', 'not_between'].includes(operator);
    if (values.length !== (range ? 2 : 1)) return false;
    if (range)
      return filter.inputType === 'inputRange' ? Number(values[0]) <= Number(values[1]) : values[0] <= values[1];
  }
  return true;
};
